<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'ContactHeader',
  inject: ['wp']
}
</script>
